// Contact Page Translations
export const contactTranslations = {
  en: {
    // Page Hero Section
    pageTitle: 'Get in Touch with Us',
    pageSubtitle: "We're here to help with all your queries, feedback, or support needs. Our dedicated team is ready to assist you anytime.",

    // Introduction Section
    introTitle: "We'd Love to Hear from You!",
    introText: 'At SubifyHub, we pride ourselves on being accessible and responsive. Whether you need assistance with your subscription, want to learn more about our services, or have valuable feedback to share, our customer support team is here for you 24/7. We\'re committed to providing you with the best experience possible.',

    // Contact Methods Section
    contactMethodsTitle: "Here's How You Can Reach Us",
    getInTouch: 'Get in Touch',

    // Contact Methods
    emailSupport: 'Email Support',
    emailDescription: 'For general inquiries, account support, and subscription issues. We respond within 24 hours.',
    emailAddress: 'contact@subifyhub.com',

    whatsappTitle: 'WhatsApp',
    whatsappDescription: 'Quick responses for urgent queries. Chat with us for faster assistance during business hours.',
    whatsappNumber: '+92 327 2341839',

    telegramTitle: 'Telegram',
    telegramDescription: 'Reach us instantly on Telegram. We typically respond within a few minutes.',
    telegramNumber: '+92 327 2341839',

    // Availability Info
    availabilityTitle: 'Available 24/7',
    emailResponseTime: 'Email: Responses within 24 hours',
    chatResponseTime: 'WhatsApp & Telegram: Instant responses during business hours (10 AM - 8 PM PKT)',
    emergencySupport: 'For emergencies, we provide round-the-clock support!',

    // FAQ Section
    lookingForAnswers: 'Looking for Answers?',

    // FAQ Items
    q1: 'How quickly do you respond to inquiries?',
    a1: 'We aim to respond to all inquiries within 24 hours. For urgent matters via WhatsApp or Telegram, we respond within minutes during business hours.',

    q2: "What should I do if I haven't received my subscription?",
    a2: 'Please contact us immediately at contact@subifyhub.com with your order ID. We\'ll investigate and resolve the issue promptly.',

    q3: 'Can I change my subscription details after purchase?',
    a3: 'Yes! You can update your subscription details anytime through your account dashboard or by contacting our support team.',

    q4: 'Do you offer refunds?',
    a4: 'We offer refunds within 7 days of purchase if you\'re not satisfied. Contact our team to initiate the refund process.',

    viewAllFaqs: 'View All FAQs',

    // Trust Section
    committedTitle: 'Committed to Your Satisfaction',
    committedText: 'Your satisfaction is our top priority. We aim to respond to all queries as quickly as possible. All customer information is handled with strict confidentiality and never shared with third parties. We comply with all data protection regulations and respect your privacy completely.',

    // Final CTA Section
    finalCtaTitle: "Have a Question? Let's Connect!",
    finalCtaText: 'Our team is ready to assist you with anything you need. Don\'t hesitate to reach out—we\'re just a message away!',
    emailUsNow: 'Email Us Now',
    whatsappUs: 'WhatsApp Us',
    telegramUs: 'Telegram Us',
  },

  fr: {
    // Page Hero Section
    pageTitle: 'Entrez en Contact Avec Nous',
    pageSubtitle: 'Nous sommes là pour vous aider avec toutes vos questions, commentaires ou besoins d\'assistance. Notre équipe dévouée est prête à vous aider à tout moment.',

    // Introduction Section
    introTitle: 'Nous Aimerions Vous Entendre!',
    introText: 'Chez SubifyHub, nous sommes fiers d\'être accessibles et réactifs. Que vous ayez besoin d\'assistance avec votre abonnement, que vous souhaitiez en savoir plus sur nos services, ou que vous ayez des commentaires précieux à partager, notre équipe d\'assistance clientèle est là pour vous 24/7. Nous nous engageons à vous offrir la meilleure expérience possible.',

    // Contact Methods Section
    contactMethodsTitle: 'Voici Comment Vous Pouvez Nous Joindre',
    getInTouch: 'Entrer en Contact',

    // Contact Methods
    emailSupport: 'Support par Email',
    emailDescription: 'Pour les questions générales, le support des comptes et les problèmes d\'abonnement. Nous répondons dans les 24 heures.',
    emailAddress: 'contact@subifyhub.com',

    whatsappTitle: 'WhatsApp',
    whatsappDescription: 'Réponses rapides pour les questions urgentes. Discutez avec nous pour une assistance plus rapide pendant les heures de travail.',
    whatsappNumber: '+92 327 2341839',

    telegramTitle: 'Telegram',
    telegramDescription: 'Nous joindre instantanément sur Telegram. Nous répondons généralement en quelques minutes.',
    telegramNumber: '+92 327 2341839',

    // Availability Info
    availabilityTitle: 'Disponible 24/7',
    emailResponseTime: 'Email: Réponses dans les 24 heures',
    chatResponseTime: 'WhatsApp & Telegram: Réponses instantanées pendant les heures de travail (10 AM - 8 PM PKT)',
    emergencySupport: 'Pour les urgences, nous proposons un support disponible 24h/24!',

    // FAQ Section
    lookingForAnswers: 'Vous Cherchez des Réponses?',

    // FAQ Items
    q1: 'Avec quelle rapidité répondez-vous aux demandes?',
    a1: 'Nous nous efforçons de répondre à toutes les demandes dans les 24 heures. Pour les questions urgentes via WhatsApp ou Telegram, nous répondons en quelques minutes pendant les heures de travail.',

    q2: "Que dois-je faire si je n'ai pas reçu mon abonnement?",
    a2: 'Veuillez nous contacter immédiatement à contact@subifyhub.com avec votre numéro de commande. Nous enquêterons et résoudrons le problème rapidement.',

    q3: 'Puis-je modifier les détails de mon abonnement après achat?',
    a3: 'Oui! Vous pouvez mettre à jour les détails de votre abonnement à tout moment via votre tableau de bord de compte ou en contactant notre équipe d\'assistance.',

    q4: 'Proposez-vous des remboursements?',
    a4: 'Nous proposons des remboursements dans les 7 jours suivant votre achat si vous n\'êtes pas satisfait. Contactez notre équipe pour lancer le processus de remboursement.',

    viewAllFaqs: 'Voir Toutes les FAQ',

    // Trust Section
    committedTitle: 'Engagement Envers Votre Satisfaction',
    committedText: 'Votre satisfaction est notre priorité absolue. Nous nous efforçons de répondre à toutes les demandes aussi rapidement que possible. Toutes les informations client sont traitées avec une stricte confidentialité et ne sont jamais partagées avec des tiers. Nous nous conformons à tous les règlements de protection des données et respectons complètement votre vie privée.',

    // Final CTA Section
    finalCtaTitle: "Avez-Vous une Question? Connectons-Nous!",
    finalCtaText: 'Notre équipe est prête à vous aider pour tout ce dont vous avez besoin. N\'hésitez pas à nous contacter—nous ne sommes qu\'à un message de distance!',
    emailUsNow: 'Nous Envoyer un Email',
    whatsappUs: 'Contactez Nous sur WhatsApp',
    telegramUs: 'Contactez Nous sur Telegram',
  },
};

export const useContactTranslations = (language = 'en') => {
  return contactTranslations[language] || contactTranslations['en'];
};
